import { Grid, Link, Typography, useMediaQuery } from '@mui/material';

const SecondaryNav = ({ data, styles }) => {
  const { length } = data.Link;
  const leftStack = data.Link.slice(0, length / 2);
  const rightStack = data.Link.slice(length / 2);
  const md = useMediaQuery(theme => theme.breakpoints.up('md'));

  return md ? (
    <Grid item xs={12} sx={styles.container}>
      {data.Link.map((nav, i) => (
        <Link
          key={i}
          underline='hover'
          sx={styles.link}
          href={nav.link}
          aria-label={nav?.ariaLabel}
        >
          <Typography variant='subtitle1' component='p'>
            {nav.text}
          </Typography>
        </Link>
      ))}
    </Grid>
  ) : (
    [leftStack, rightStack].map((linkData, i) => (
      <Grid item key={i} xs={6} sx={styles.container}>
        {linkData.map((nav, key) => (
          <Link
            key={key}
            underline='hover'
            sx={styles.link}
            href={nav.link}
            aria-label={nav?.ariaLabel}
          >
            <Typography variant='subtitle1' component='p'>
              {nav.text}
            </Typography>
          </Link>
        ))}
      </Grid>
    ))
  );
};

export default SecondaryNav;
